export default "__VITE_ASSET__CC_Pc$n1__"